const imageUploadStatuses = {
	ok: 'OK',
	partial: 'Partial',
	error: 'Error',
	none: 'None'
};

export { imageUploadStatuses };
